import de from './de.png';
import en from './en.png';
import fr from './fr.png';

export default { de, en, fr };
